import React from 'react';
import PageContainer from '../PageContainer';
import Slider from '../slider/slider';
import { greyText } from '../styles';
import './repository.scss';
import repo2 from './nazli.jpg';
import repo3 from './repo2.jpg';
import repo1 from './repo3.jpg';
import { MediaQueryContext } from '../MediaQueryContext';
import PageTitle from '../PageTitle';



class Repository extends React.Component {
  static contextType = MediaQueryContext;


  slides() {
    return [
      <div className="repository-slide" key="repo-1" style={{ backgroundImage: this.context.isMobile ? `url(${repo1})` : null }} >
        {this.context.isMobile && <div className="backdrop" />}

        <div className="image-container">
          <div className="repo-image" style={{ backgroundImage: `url(${repo1})` }} />

        </div>
        <span className="quote">“</span>

        <div className="slide-content">
          <h2>I B I</h2>
          <p style={{ color: 'white' }}>“I am a language guy. Learning a new language helps you to see things from a different perspective. When you learn a new language, you discover a different version of yourself.”</p>
          <p style={{ color: greyText }}>«Jeg er en språk-fyr. Å lære et nytt språk g jør det lettere til å se ting fra ulike perspektiver. Når man lærer et nytt språk så oppdager man en annen versjon av seg selv.»</p>

        </div>

      </div>,
      <div className="repository-slide" key="repo-2" style={{ backgroundImage: this.context.isMobile ? `url(${repo2})` : null }} >
        {this.context.isMobile && <div className="backdrop" />}
        <div className="image-container">
          <div className="repo-image" style={{ backgroundImage: `url(${repo2})` }} />

        </div>
        <span className="quote">“</span>

        <div className="slide-content">
          <h2>N A Z R I</h2>
          <p style={{ color: 'white' }}>“When I am feeling sad about my situation, I look up into the sky and feel peace; sometimes up there, I can find the answer I’m looking for.”</p>
          <p style={{ color: 'white' }}>“I am learning every day to allow the space between where I am and where I want to be to inspire me and not terrify me.” – Tracee Ellis Ross</p>

          <p style={{ color: greyText }}>«Når jeg føler meg trist på grunn av min situasjon, så kikker jeg opp på himmelen og føler ro; iblant finner jeg svarene jeg leter etter der oppe.»</p>
          <p style={{ color: greyText }}>«Hver dag lærer jeg å la avstanden mellom hvor jeg er nå og hvor jeg ønsker å være, være en inspirasjon fremfor å skremme meg.» – Tracee Ellis Ross</p>

        </div>

      </div>,
      <div className="repository-slide" key="repo-3" style={{ backgroundImage: this.context.isMobile ? `url(${repo3})` : null }}  >
        {this.context.isMobile && <div className="backdrop" />}

        <div className="image-container">
          <div className="repo-image" style={{ backgroundImage: `url(${repo3})` }} />

        </div>
        <span className="quote">“</span>

        <div className="slide-content">
          <h2>I S R A A</h2>
          <p style={{ color: 'white' }}>“My identity is linked very closely to where I come from. Palestinian embroidery - tatreez, is an important part of my cultural heritage. It is a tangible proof that the Palestinian people have lived in the land of Palestine for thousands of years and therefore have a right to the land of their ancestors.”</p>
          <p style={{ color: greyText }}>«Min identitet er sterkt knyttet til hvor jeg kommer fra. Palestinsk broderi - tatreez, er en viktig del av min kulturarv. Det er et håndgripelig bevis på at det palestinske folket har levd i Palestina i over tusen år og har derfor rett på sine forfedres land.»</p>

        </div>

      </div>,


    ]
  }

  componentDidMount() {
    this.props.setBackgroundImage('url(' + repo1 + ')');
  }

  onSlide(i) {
    let bgs = [repo1, repo2, repo3];

    this.props.setBackgroundImage('url(' + bgs[i] + ')');
  }

  render() {
    return (
      <PageContainer {...this.props} className="repository" >
        <div className="page-subtitle">
          <i>
            <span>Projected portrait photography of three individuals from varied minority groups: Kurdish, LGBTQ+ and Palestinian</span>
            <br />
            <span style={{ color: greyText }}>Prosjekterte portrett fotografier av tre individer med ulike minoritetsbakgrunner: kurdisk, LHBTI+ og Palestinsk</span>
            <br />
            <span>Photographs by Katrina Flett Gulbrandsen</span>
          </i>
        </div>

        <div className="mobile-slides">
          {!this.context.isDesktop && this.slides()}

        </div>

        {this.context.isDesktop &&
          <Slider onSlide={this.onSlide.bind(this)} slides={this.slides()} />
        }
        <PageTitle >REPOSITORY</PageTitle>

      </PageContainer>
    );
  }
}
export default Repository;
